import { UncontrolledPopover } from 'reactstrap';
import styled from 'styled-components';

import { colors, fonts } from 'shared/defaultTheme';

const PopoverWrapper = styled(UncontrolledPopover)`
  font-family: ${fonts.medium};
  .popover {
    background-color: ${colors.white};
    box-shadow: 2px 2px 4px 0 ${colors.gullGrey};
    min-height: 157px;
    padding: 16px 6px;
    left: -40px !important;
    width: 216px;
    z-index: 700;
  }
  .popover-body {
    padding: 0;
  }
  .arrow {
    display: none;
  }
  .button {
    width: 98px;
  }
`;

export { PopoverWrapper };
